import {
  CustomViewOperator,
  getOperatorsByUiType,
  isUnary,
} from 'src/graphql/entities/custom-view/custom-view-config/operators';
import {
  type CustomViewFormConditionField,
  type CustomViewFormConditionItem,
  UIType,
} from 'src/graphql/entities/custom-view/custom-view.types';

export type OptionItem = { id: string; label: string; value: string } & Record<
  string,
  unknown
>;

export const operatorsForField = (
  field?: CustomViewFormConditionField,
): CustomViewOperator[] => (field ? getOperatorsByUiType(field.uiType) : []);

export const UI_TYPE_ICON: Partial<Record<UIType, string>> = {
  [UIType.List]: 'checklist',
  [UIType.Text]: 'title',
  [UIType.Textarea]: 'notes',
  [UIType.Number]: 'tag',
  [UIType.Date]: 'calendar_today',
  [UIType.Boolean]: 'toggle_on',
};

export const iconForUiType = (uiType?: UIType) =>
  (uiType && UI_TYPE_ICON[uiType]) || 'filter_alt';

export const emptyValueFor = (
  field: CustomViewFormConditionField | undefined,
  multi: boolean,
): CustomViewFormConditionItem['value'] => {
  if (multi) return [];
  if (field?.uiType === UIType.List) return undefined;
  return '';
};

export const isValueReady = (draft: CustomViewFormConditionItem | null) => {
  if (!draft?.field || !draft.operator) return false;
  if (isUnary(draft.operator)) return true;
  const { value } = draft;
  if (Array.isArray(value)) return value.length > 0;
  if (value && typeof value === 'object') return true;
  if (typeof value === 'string') return value.trim().length > 0;
  return value !== undefined && value !== null;
};
